import { useTranslation } from "react-i18next";

import { titleStyles } from "../../../../configs";
import { MODAL_STEPS } from "../../../../constants/modal";
import { capitalizeFirstLetter, useIsMobile } from "../../../../utils";
import { findBrandByDomain } from "../../../../configs/configLoader";

import "../../index.css";

interface DescriptionBlockProps {
  step: {
    number: number;
  } | null;
  selectedGender: string;
  translatedGender: string;
  titlesStyles: React.CSSProperties;
  descriptionStyles: React.CSSProperties;
}

const DescriptionBlock: React.FC<DescriptionBlockProps> = ({
  step,
  selectedGender,
  translatedGender,
  titlesStyles,
  descriptionStyles,
}) => {
  const isMobile = useIsMobile();

  const { t } = useTranslation("components/intro");

  const brandDefined = findBrandByDomain();

  const isMobileSRP = isMobile && brandDefined?.name === "SRP";
  const isVB = brandDefined?.name === "Victoria Beckham";
  const isSRP = brandDefined?.name === "SRP";
  const isVelour = brandDefined?.name === "Velour Garments";
  const isGivenchy = brandDefined?.name === "Givenchy";
  const isTDF = brandDefined?.name === "TDF";

  const isGivenchyMobile = isGivenchy && isMobile;

  return (
    <>
      {!isVB && !isVelour ? (
        <>
          {!isMobile || isGivenchyMobile || (isTDF && isMobile) ? (
            <span
              className="description"
              style={{
                ...descriptionStyles,
                lineHeight: isGivenchy ? "20px" : "",
              }}
            >
              {descriptionStyles?.textTransform === "capitalize"
                ? capitalizeFirstLetter(t("description"))
                : t("description")}
            </span>
          ) : null}
          {isGivenchy ? (
            <span
              className="description"
              style={{
                ...titlesStyles,
                color: titleStyles.color as React.CSSProperties["color"],
                fontSize: descriptionStyles?.fontSize,
                marginBottom: "20px",
                marginTop: isMobile ? "40px" : "",
                textTransform: "unset",
              }}
            >
              {descriptionStyles.textTransform === "capitalize"
                ? capitalizeFirstLetter(t("descriptionSecond"))
                : t("descriptionSecond")}
            </span>
          ) : null}
          {((isMobile && step?.number === MODAL_STEPS.GENDER.number) ||
            isMobileSRP) && (
            <span
              className="descriptionSmall"
              style={descriptionStyles}
              dangerouslySetInnerHTML={{
                __html:
                  (descriptionStyles.textTransform as string) === "capitalize"
                    ? capitalizeFirstLetter(
                        t(isSRP ? "description" : "gender.title", {
                          value: selectedGender
                            ? isGivenchy
                              ? capitalizeFirstLetter(translatedGender)
                              : capitalizeFirstLetter(selectedGender)
                            : t("Select"),
                        }),
                      )
                    : t(isSRP ? "description" : "gender.title", {
                        value: selectedGender
                          ? isGivenchy
                            ? capitalizeFirstLetter(translatedGender)
                            : capitalizeFirstLetter(selectedGender)
                          : t("Select"),
                      }),
              }}
            ></span>
          )}
          {isMobileSRP && step?.number === MODAL_STEPS.GENDER.number && (
            <span className="descriptionSmall" style={titlesStyles}>
              {(descriptionStyles.textTransform as string) === "capitalize"
                ? capitalizeFirstLetter(t("gender.title"))
                : t("gender.title")}
            </span>
          )}
        </>
      ) : null}
    </>
  );
};

export default DescriptionBlock;
